// European Championshop Men, European Championship Women, FIBA (basketball) World Cup, FIFA World Cup, Women's World Cup, Rugby World Cup
export const quadrennialComps = [41200316, 1874565, 33839333, 26249831, 33751633, 34416534];
